'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isLastMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isLastMonth.js
// module id = 544
// module chunks = 0